export default function RedirectCard({ request, onCancel, message }) {
  const isAlreadySubmitted =
    request === "already_submitted" ||
    message?.request === "already_submitted" ||
    message?.message?.message === "already_submitted";
  
  const requestState = isAlreadySubmitted ? "already_submitted" : request;

  const errorDetails =
    message?.message?.details ||
    message?.message ||
    message?.ERROR?.details ||
    message?.ERROR ||
    "Unfortunately! your submission failed. Please contact our customer service team.";
  
  return (
    <div className="justify-center items-center md:inset-0 h-modal sm:h-full">
      <div className="relative px-4 w-full max-w-md h-full md:h-auto">
        <div className="bg-white rounded-lg shadow">
          <div className="p-6 text-center">
            {requestState === "good" ? <GoodRequest /> : 
             requestState === "already_submitted" ? <AlreadySubmittedRequest /> : 
             <BadRequest />}
            
            {requestState === "good" ? <GoodRequestText /> : 
             requestState === "already_submitted" ? 
             <h3 className="mb-5 text-lg font-normal text-gray-500">
               {message?.message?.details || message?.ERROR?.details || "You have already submitted a form. Please visit the nearest branch to get help from our agents."}
             </h3> : 
             <BadRequestText text={errorDetails} />}

          </div>
        </div>
      </div>
    </div>
  );
}

function BadRequest() {
  return (
    <svg
      className="mx-auto mb-4 w-14 h-14 text-red-400"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
}

function AlreadySubmittedRequest() {
  return (
    <svg
      className="mx-auto mb-4 w-14 h-14 text-yellow-400"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
}

function GoodRequest() {
  return (
    <svg
      className="mx-auto mb-4 w-14 h-14 text-green-400"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
}

function GoodRequestText() {
  return (
    <h3 className="mb-5 text-lg font-normal text-gray-500">
      We received your request and you will receive a mail from us as soon as
      possible.
    </h3>
  );
}

function AlreadySubmittedText() {
  return (
    <h3 className="mb-5 text-lg font-normal text-gray-500">
      You have already submitted a form. Please visit the nearest branch to get help from our agents.
    </h3>
  );
}

function BadRequestText({ text }) {
  return (
    <h3 className="mb-5 text-lg font-normal text-gray-500">
      {text}
    </h3>
  );
}